import { createFileRoute } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import { Globe, Info, ArrowLeft } from 'lucide-react';

export const Route = createFileRoute('/_auth/regions')({
  component: RegionsPage,
});

export default function RegionsPage() {
  const regions = [
    { name: 'EU-West (Finland)', code: 'eu-west-1', status: 'primary', uptime: '99.98%', latency: '12ms', note: 'Current primary deployment' },
    { name: 'EU-Central (Germany)', code: 'eu-central-1', status: 'active', uptime: '99.97%', latency: '18ms', note: 'Active secondary region' },
    { name: 'US-East', code: 'us-east-1', status: 'planned', uptime: '—', latency: '—', note: 'Planned Q3 2025' },
  ];

  const statusColors: Record<string, { bg: string; text: string; label: string }> = {
    primary:  { bg: '#6366f120', text: '#818cf8', label: 'Primary' },
    active:   { bg: '#10b98115', text: '#34d399', label: 'Active' },
    planned:  { bg: '#64748b20', text: '#94a3b8', label: 'Planned' },
    degraded: { bg: '#ef444415', text: '#f87171', label: 'Degraded' },
  };

  return (
    <div className="page">
      <Link to="/settings" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#64748b', marginBottom: 20, textDecoration: 'none' }}>
        <ArrowLeft size={14} /> Back to Settings
      </Link>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
        <Globe size={22} style={{ color: '#6366f1' }} />
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#e2e8f0' }}>Regions & Infrastructure</h1>
      </div>
      <p style={{ margin: '0 0 28px', fontSize: 13, color: '#64748b' }}>
        Deployment regions and data residency for the enska.ai platform. Enterprise tenants may request dedicated region assignment.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {regions.map(r => {
          const s = statusColors[r.status] ?? statusColors.active;
          return (
            <div key={r.code} style={{
              display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px',
              borderRadius: 12, border: '1px solid #1a1f35', background: 'var(--color-surface)',
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#e2e8f0' }}>{r.name}</div>
                <div style={{ fontSize: 11, color: '#64748b', fontFamily: 'monospace', marginTop: 2 }}>{r.code} · {r.note}</div>
              </div>
              <div style={{ textAlign: 'right', fontSize: 12, color: '#64748b' }}>
                <div>Uptime: <span style={{ color: '#94a3b8' }}>{r.uptime}</span></div>
                <div>P50: <span style={{ color: '#94a3b8' }}>{r.latency}</span></div>
              </div>
              <span style={{
                padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                background: s.bg, color: s.text,
              }}>
                {s.label}
              </span>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 24, padding: '12px 16px', borderRadius: 8, background: '#0a0e1c', fontSize: 12, color: '#475569', border: '1px solid #1a1f35', display: 'flex', gap: 8, alignItems: 'flex-start' }}>
        <Info size={13} style={{ color: '#6366f1', flexShrink: 0, marginTop: 1 }} />
        Multi-region routing and tenant-level data residency assignment are planned features. Contact support for Enterprise region requirements.
      </div>
    </div>
  );
}
